<ion-card
  class="ion-no-margin card-white-background-color"
  [ngClass]="isMarginRight ? 'marr10' : ''"
  [style.width]="width"
  (click)="navigateToServiceDetailsPage()"
>
  <div class="img-container">
    <img [src]="service?.img" class="store-img" [style.height]="height" />
    <div
      *ngIf="service?.tags && service?.tags.length > 0"
      class="cashback-container"
    >
      <div class="chip-container">
        <ion-chip [ngClass]="'primary-chip lite-chip ion-text-capitalize'">
          <ion-text class="font700 fs-2">
            {{service?.tags?.[0]}}
          </ion-text>
        </ion-chip>
      </div>
    </div>
  </div>

  <ion-chip class="tertiary-chip discount-chip" *ngIf="service?.discount && service?.discount > 0"
    ><ion-text>{{ service?.discount | number : "1.0-0" }}% Off</ion-text>
  </ion-chip>
  <div class="d-flex content-container ion-justify-content-between">
    <div class="content-container-text">
      <ion-card-title class="fs-2 font400 card-secondary-text-color">{{
        service?.city
      }}</ion-card-title>
      <ion-text class="fs-2 font600 card-primary-text-color line-2-clip">
        {{ service?.title }}
      </ion-text>
    </div>
    <div class="d-flex flex-col padl10">
      <span class="primary-price-color fs-3 font700">
        {{ service?.finalPrice | currency : currencyCode }}
      </span>
      <span
        class="strike-price-color fs-2 font200"
        *ngIf="service?.finalPrice < service?.origPrice"
      >
        {{ service?.origPrice | currency : currencyCode }}
      </span>
    </div>
  </div>
</ion-card>
